import * as yup from 'yup';

const roles = {
  GUARDIAN_SYSOPS: 'GUARDIAN_SYSOPS',
  GUARDIAN_ADMIN: 'GUARDIAN_ADMIN',
  GUARDIAN_DEV: 'GUARDIAN_DEV',
  GUARDIAN_VIEWER: 'GUARDIAN_VIEWER',
  ISP_ADMIN: 'ISP_ADMIN',
  ISP_DEV: 'ISP_DEV',
  ISP_VIEWER: 'ISP_VIEWER',
  FIRMWARE_ADMIN: 'FIRMWARE_ADMIN'
};

// ***** The values should be the lowercase of the keys, otherwise the permissions list will not work *****
const permissions = {
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  VIEW_ACCOUNTS: 'VIEW_ACCOUNTS',
  VIEW_DEVICES: 'VIEW_DEVICES',
  VIEW_ISPS: 'VIEW_ISPS',
  VIEW_SELF_ISP: 'VIEW_SELF_ISP',
  VIEW_MODELS: 'VIEW_MODELS',
  VIEW_FIRMWARE_UPDATES: 'VIEW_FIRMWARE_UPDATES',
  VIEW_FIRMWARE_UPDATE_TEST_GROUPS: 'VIEW_FIRMWARE_UPDATE_TEST_GROUPS',
  VIEW_IOT_JOBS: 'VIEW_IOT_JOBS',
  VIEW_GROUPS: 'VIEW_GROUPS',
  VIEW_NETWORKS: 'VIEW_NETWORKS',
  VIEW_WHITELIST: 'VIEW_WHITELIST',
  VIEW_PRIVACY_GUI: 'VIEW_PRIVACY_GUI',
  VIEW_PRIVACY_GUI_GROUPS: 'VIEW_PRIVACY_GUI_GROUPS',
  SEARCH_GUARDIAN_ACCOUNTS: 'SEARCH_GUARDIAN_ACCOUNTS',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  CREATE_ISP: 'CREATE_ISP',
  CREATE_IOT_JOB: 'CREATE_IOT_JOB',
  CREATE_GROUPS: 'CREATE_GROUPS',
  DUPLICATE_FIRMWARE_UPDATE: 'DUPLICATE_FIRMWARE_UPDATE',
  EDIT_SYSOPS_ROLE: 'EDIT_SYSOPS_ROLE',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  EDIT_ACCOUNT_PASSWORD: 'EDIT_ACCOUNT_PASSWORD',
  EDIT_SELF_PASSWORD: 'EDIT_SELF_PASSWORD',
  EDIT_ACCOUNT_GUARDIAN_ROLE: 'EDIT_ACCOUNT_GUARDIAN_ROLE',
  EDIT_ACCOUNT_ISP_ROLE: 'EDIT_ACCOUNT_ISP_ROLE',
  EDIT_SELF_PROFILE: 'EDIT_SELF_PROFILE',
  EDIT_ISP: 'EDIT_ISP',
  EDIT_ISP_OAUTH: 'EDIT_ISP_OAUTH',
  EDIT_MODEL: 'EDIT_MODEL',
  EDIT_FIRMWARE_UPDATE: 'EDIT_FIRMWARE_UPDATE',
  EDIT_FIRMWARE_UPDATE_ACCESS: 'EDIT_FIRMWARE_UPDATE_ACCESS',
  EDIT_FIRMWARE_UPDATE_TEST_GROUP: 'EDIT_FIRMWARE_UPDATE_TEST_GROUP',
  EDIT_FIRMWARE_UPDATE_MODELS: 'EDIT_FIRMWARE_UPDATE_MODELS',
  EDIT_IOT_JOB: 'EDIT_IOT_JOB',
  EDIT_GROUPS: 'EDIT_GROUPS',
  EDIT_WHITELIST: 'EDIT_WHITELIST',
  CREATE_PRIVACY_GUI: 'CREATE_PRIVACY_GUI',
  EDIT_PRIVACY_GUI_GROUPS: 'EDIT_PRIVACY_GUI_GROUPS',
  LOCK_FIRMWARE_UPDATE: 'LOCK_FIRMWARE_UPDATE',
  LOCK_FIRMWARE_UPDATE_TEST_GROUP: 'LOCK_FIRMWARE_UPDATE_TEST_GROUP',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  DELETE_ISP: 'DELETE_ISP',
  DELETE_FIRMWARE_UPDATE: 'DELETE_FIRMWARE_UPDATE',
  DELETE_FIRMWARE_UPDATE_TEST_GROUP: 'DELETE_FIRMWARE_UPDATE_TEST_GROUP',
  DELETE_IOT_JOB: 'DELETE_IOT_JOB',
  DELETE_GROUPS: 'DELETE_GROUPS',
  DISABLE_PRIVACY_GUI: 'DISABLE_PRIVACY_GUI',
  DELETE_PRIVACY_GUI_GROUPS: 'DELETE_PRIVACY_GUI_GROUPS',
  REBUILD_PRIVACY_GUI: 'REBUILD_PRIVACY_GUI',
  REBUILD_PRIVACY_GUI_GROUPS: 'REBUILD_PRIVACY_GUI_GROUPS',
  USE_CHATBOT: 'USE_CHATBOT',
  SEND_JNAP: 'SEND_JNAP',
  REMOTE_ASSISTANCE: 'REMOTE_ASSISTANCE',
  EDIT_GUARDIAN_OAUTH: 'EDIT_GUARDIAN_OAUTH'
};
// ***** The values should be the lowercase of the keys, otherwise the permissions list will not work *****

const rolePermissions = {
  [roles.GUARDIAN_SYSOPS]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_DEVICES,
    permissions.VIEW_ISPS,
    permissions.VIEW_SELF_ISP,
    permissions.VIEW_MODELS,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.VIEW_IOT_JOBS,
    permissions.VIEW_GROUPS,
    permissions.VIEW_NETWORKS,
    permissions.VIEW_WHITELIST,
    permissions.VIEW_PRIVACY_GUI,
    permissions.VIEW_PRIVACY_GUI_GROUPS,
    permissions.SEARCH_GUARDIAN_ACCOUNTS,
    permissions.CREATE_ACCOUNT,
    permissions.CREATE_ISP,
    permissions.CREATE_IOT_JOB,
    permissions.CREATE_GROUPS,
    permissions.DUPLICATE_FIRMWARE_UPDATE,
    permissions.EDIT_SYSOPS_ROLE,
    permissions.EDIT_ACCOUNT,
    permissions.EDIT_ACCOUNT_GUARDIAN_ROLE,
    permissions.EDIT_ACCOUNT_ISP_ROLE,
    permissions.EDIT_ACCOUNT_PASSWORD,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.EDIT_ISP,
    permissions.EDIT_ISP_OAUTH,
    permissions.EDIT_GUARDIAN_OAUTH,
    permissions.EDIT_MODEL,
    permissions.EDIT_FIRMWARE_UPDATE,
    permissions.EDIT_FIRMWARE_UPDATE_ACCESS,
    permissions.EDIT_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.EDIT_FIRMWARE_UPDATE_MODELS,
    permissions.EDIT_IOT_JOB,
    permissions.EDIT_GROUPS,
    permissions.EDIT_WHITELIST,
    permissions.CREATE_PRIVACY_GUI,
    permissions.EDIT_PRIVACY_GUI_GROUPS,
    permissions.LOCK_FIRMWARE_UPDATE,
    permissions.LOCK_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_ACCOUNT,
    permissions.DELETE_ISP,
    permissions.DELETE_FIRMWARE_UPDATE,
    permissions.DELETE_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_IOT_JOB,
    permissions.USE_CHATBOT,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE,
    permissions.DELETE_GROUPS,
    permissions.DISABLE_PRIVACY_GUI,
    permissions.DELETE_PRIVACY_GUI_GROUPS,
    permissions.REBUILD_PRIVACY_GUI,
    permissions.REBUILD_PRIVACY_GUI_GROUPS
  ],
  [roles.GUARDIAN_ADMIN]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_DEVICES,
    permissions.VIEW_ISPS,
    permissions.VIEW_SELF_ISP,
    permissions.VIEW_MODELS,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.VIEW_IOT_JOBS,
    permissions.VIEW_GROUPS,
    permissions.VIEW_NETWORKS,
    permissions.VIEW_PRIVACY_GUI,
    permissions.VIEW_PRIVACY_GUI_GROUPS,
    permissions.SEARCH_GUARDIAN_ACCOUNTS,
    permissions.CREATE_ACCOUNT,
    permissions.CREATE_ISP,
    permissions.CREATE_IOT_JOB,
    permissions.CREATE_GROUPS,
    permissions.DUPLICATE_FIRMWARE_UPDATE,
    permissions.EDIT_ACCOUNT,
    permissions.EDIT_ACCOUNT_GUARDIAN_ROLE,
    permissions.EDIT_ACCOUNT_ISP_ROLE,
    permissions.EDIT_ACCOUNT_PASSWORD,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.EDIT_ISP,
    permissions.EDIT_ISP_OAUTH,
    permissions.EDIT_MODEL,
    permissions.EDIT_FIRMWARE_UPDATE,
    permissions.EDIT_FIRMWARE_UPDATE_ACCESS,
    permissions.EDIT_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.EDIT_FIRMWARE_UPDATE_MODELS,
    permissions.EDIT_IOT_JOB,
    permissions.EDIT_GROUPS,
    permissions.CREATE_PRIVACY_GUI,
    permissions.EDIT_PRIVACY_GUI_GROUPS,
    permissions.LOCK_FIRMWARE_UPDATE,
    permissions.LOCK_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_ACCOUNT,
    permissions.DELETE_ISP,
    permissions.DELETE_FIRMWARE_UPDATE,
    permissions.DELETE_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_IOT_JOB,
    permissions.USE_CHATBOT,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE,
    permissions.DELETE_GROUPS,
    permissions.DISABLE_PRIVACY_GUI,
    permissions.DELETE_PRIVACY_GUI_GROUPS,
    permissions.REBUILD_PRIVACY_GUI,
    permissions.REBUILD_PRIVACY_GUI_GROUPS
  ],
  [roles.GUARDIAN_DEV]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_GROUPS,
    permissions.VIEW_NETWORKS,
    permissions.VIEW_PRIVACY_GUI,
    permissions.VIEW_PRIVACY_GUI_GROUPS,
    permissions.CREATE_IOT_JOB,
    permissions.CREATE_GROUPS,
    permissions.EDIT_ACCOUNT,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.EDIT_FIRMWARE_UPDATE,
    permissions.EDIT_FIRMWARE_UPDATE_ACCESS,
    permissions.EDIT_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.EDIT_FIRMWARE_UPDATE_MODELS,
    permissions.EDIT_IOT_JOB,
    permissions.EDIT_GROUPS,
    permissions.EDIT_PRIVACY_GUI_GROUPS,
    permissions.SEARCH_GUARDIAN_ACCOUNTS,
    permissions.VIEW_DEVICES,
    permissions.VIEW_ISPS,
    permissions.VIEW_SELF_ISP,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.VIEW_IOT_JOBS,
    permissions.DELETE_IOT_JOB,
    permissions.DELETE_GROUPS,
    permissions.DELETE_PRIVACY_GUI_GROUPS,
    permissions.USE_CHATBOT,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE,
    permissions.DISABLE_PRIVACY_GUI,
    permissions.REBUILD_PRIVACY_GUI,
    permissions.REBUILD_PRIVACY_GUI_GROUPS,
    permissions.LOCK_FIRMWARE_UPDATE,
    permissions.LOCK_FIRMWARE_UPDATE_TEST_GROUP
  ],
  [roles.GUARDIAN_VIEWER]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_GROUPS,
    permissions.VIEW_NETWORKS,
    permissions.VIEW_PRIVACY_GUI,
    permissions.VIEW_PRIVACY_GUI_GROUPS,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.VIEW_DEVICES,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.VIEW_IOT_JOBS,
    permissions.USE_CHATBOT,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE,
    permissions.SEARCH_GUARDIAN_ACCOUNTS
  ],
  [roles.ISP_ADMIN]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_DEVICES,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.VIEW_IOT_JOBS,
    permissions.VIEW_GROUPS,
    permissions.CREATE_ACCOUNT,
    permissions.CREATE_GROUPS,
    permissions.DUPLICATE_FIRMWARE_UPDATE,
    permissions.CREATE_IOT_JOB,
    permissions.EDIT_ACCOUNT,
    permissions.EDIT_ACCOUNT_ISP_ROLE,
    permissions.EDIT_ACCOUNT_PASSWORD,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.EDIT_FIRMWARE_UPDATE,
    permissions.EDIT_FIRMWARE_UPDATE_ACCESS,
    permissions.EDIT_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.EDIT_IOT_JOB,
    permissions.EDIT_GROUPS,
    permissions.LOCK_FIRMWARE_UPDATE,
    permissions.LOCK_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_ACCOUNT,
    permissions.DELETE_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_IOT_JOB,
    permissions.DELETE_GROUPS,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE
  ],
  [roles.ISP_DEV]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_IOT_JOBS,
    permissions.VIEW_GROUPS,
    permissions.CREATE_IOT_JOB,
    permissions.CREATE_GROUPS,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.VIEW_DEVICES,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.EDIT_FIRMWARE_UPDATE,
    permissions.EDIT_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.EDIT_IOT_JOB,
    permissions.EDIT_GROUPS,
    permissions.DELETE_IOT_JOB,
    permissions.DELETE_GROUPS,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE
  ],
  [roles.ISP_VIEWER]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_IOT_JOBS,
    permissions.VIEW_GROUPS,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_SELF_PROFILE,
    permissions.VIEW_DEVICES,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.SEND_JNAP,
    permissions.REMOTE_ASSISTANCE
  ],
  [roles.FIRMWARE_ADMIN]: [
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_ACCOUNTS,
    permissions.VIEW_DEVICES,
    permissions.VIEW_ISPS,
    permissions.VIEW_SELF_ISP,
    permissions.VIEW_FIRMWARE_UPDATES,
    permissions.VIEW_FIRMWARE_UPDATE_TEST_GROUPS,
    permissions.DUPLICATE_FIRMWARE_UPDATE,
    permissions.EDIT_SELF_PASSWORD,
    permissions.EDIT_FIRMWARE_UPDATE,
    permissions.EDIT_FIRMWARE_UPDATE_ACCESS,
    permissions.EDIT_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.EDIT_FIRMWARE_UPDATE_MODELS,
    permissions.LOCK_FIRMWARE_UPDATE,
    permissions.LOCK_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.DELETE_FIRMWARE_UPDATE,
    permissions.DELETE_FIRMWARE_UPDATE_TEST_GROUP,
    permissions.SEND_JNAP
  ]
};

const passwordPolicy = yup
  .string()
  .min(10, 'Password should be of minimum 10 characters length')
  .max(60, 'Password should be of maximum 60 characters length')
  .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
  .matches(/[0-9]/, 'Password must contain at least one number')
  .matches(/[@$!%*?&#]/, 'Password must contain at least one special character')
  .required('Password is required');

export { passwordPolicy, permissions, rolePermissions, roles };
